var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocSubmitted = function SvgDocSubmitted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#34B7C9",
    d: "M51.35 12.45c1.59 0 3.11.64 4.24 1.76L72.06 30.7a6 6 0 0 1 1.76 4.24v33.51c0 4.41-3.59 8-8 8h-32c-4.41 0-8-3.59-8-8v-48c0-4.41 3.59-8 8-8h17.53m14.47 62c3.31 0 6-2.69 6-6V34.94c0-.16 0-.32-.02-.49H56.82c-2.76 0-5-2.24-5-5V14.47c-.16-.01-.33-.02-.49-.02H33.82c-3.31 0-6 2.69-6 6v48c0 3.31 2.69 6 6 6zM54.16 15.61c-.1-.1-.21-.2-.34-.3v14.14c0 1.66 1.34 3 3 3h14.12a5 5 0 0 0-.3-.34l-16.49-16.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34B7C9",
    d: "M47.2 60.82a.996.996 0 0 1-1.41 0l-6.66-6.67a.996.996 0 0 1 0-1.41c.39-.38 1.03-.39 1.41 0l5.96 5.96 12.62-12.62a.996.996 0 1 1 1.41 1.41L47.19 60.83z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#34B7C9",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M9.74 36.3 8.4 39.22c-.07.16-.07.34 0 .5l1.34 2.92a.604.604 0 0 1-.8.8L6.02 42.1a.62.62 0 0 0-.5 0L2.6 43.44a.604.604 0 0 1-.8-.8l1.34-2.92c.07-.16.07-.34 0-.5L1.8 36.3a.604.604 0 0 1 .8-.8l2.92 1.34c.16.07.34.07.5 0l2.92-1.34c.51-.23 1.03.29.8.8ZM85.85 11.28l-1.34 2.92c-.07.16-.07.34 0 .5l1.34 2.92a.604.604 0 0 1-.8.8l-2.92-1.34a.62.62 0 0 0-.5 0l-2.92 1.34a.604.604 0 0 1-.8-.8l1.34-2.92c.07-.16.07-.34 0-.5l-1.34-2.92a.604.604 0 0 1 .8-.8l2.92 1.34c.16.07.34.07.5 0l2.92-1.34c.51-.23 1.03.29.8.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#34B7C9",
    fillRule: "evenodd",
    d: "M20.37.8a.8.8 0 1 0-1.6 0V4h-3.2a.8.8 0 0 0 0 1.6h3.2v3.2a.8.8 0 0 0 1.6 0V5.6h3.2a.8.8 0 1 0 0-1.6h-3.2z",
    clipRule: "evenodd"
  })));
};
export default SvgDocSubmitted;